export default {
  "mainVegetable": "verduras",
  "mainVegetable/01": "verduras/berenjenas",
  "mainVegetable/02": "verduras/esparragos",
  "mainVegetable/03": "verduras/aguacate",
  "mainVegetable/04": "verduras/remolacha",
  "mainVegetable/05": "verduras/brocoli",
  "mainVegetable/06": "verduras/zanahorias",
  "mainVegetable/07": "verduras/apio",
  "mainVegetable/08": "verduras/champinones",
  "mainVegetable/09": "verduras/col",
  "mainVegetable/10": "verduras/coles-de-bruselas",
  "mainVegetable/11": "verduras/col-china",
  "mainVegetable/12": "verduras/coliflor",
  "mainVegetable/13": "verduras/ensalada-de-col",
  "mainVegetable/14": "verduras/pepino",
  "mainVegetable/15": "verduras/calabacines",
  "mainVegetable/16": "verduras/endibias",
  "mainVegetable/17": "verduras/espinacas",
  "mainVegetable/18": "verduras/habas",
  "mainVegetable/19": "verduras/alubias-verdes",
  "mainVegetable/20": "verduras/judias-planas",
  "mainVegetable/21": "verduras/alubias-secas",
  "mainVegetable/22": "verduras/judias-verdes",
  "mainVegetable/23": "verduras/lentejas",
  "mainVegetable/24": "verduras/macedoina-de-verduras",
  "mainVegetable/25": "verduras/maiz",
  "mainVegetable/26": "verduras/mezclum",
  "mainVegetable/27": "verduras/nabo",
  "mainVegetable/28": "verduras/cebollas",
  "mainVegetable/29": "verduras",
  "mainVegetable/30": "verduras/pimientos",
  "mainVegetable/31": "verduras/patatas",
  "mainVegetable/32": "verduras/brotes-de-soja",
  "mainVegetable/33": "verduras/rabanos",
  "mainVegetable/34": "verduras/ensalada-de-hojas-de-roble",
  "mainVegetable/35": "verduras/ensalada-rizada",
  "mainVegetable/36": "verduras/ensalada-iceberg",
  "mainVegetable/37": "verduras/ensalada-piamontesa",
  "mainVegetable/38": "verduras/ensaladas-de-arroz",
  "mainVegetable/39": "verduras/ensalada-romana",
  "mainVegetable/40": "verduras/brotes-jovenes",
  "mainVegetable/41": "verduras/lechuga",
  "mainVegetable/42": "verduras/canonigo",
  "mainVegetable/43": "verduras/rucula",
  "mainVegetable/44": "verduras/salsifi",
  "mainVegetable/45": "verduras/taboule",
  "mainVegetable/46": "verduras/tomates",
  "mainVegetable/47": "verduras/judias-crema",
  "mainVegetable/48": "verduras/garbanzo",
  "mainVegetable/49": "verduras/puerros",
  "mainVegetable/50": "verduras/calabaza",
  "mainVegetable/51": "verduras/alubias-rojas",
  "mainVegetable/52": "verduras/manzanas",
  "mainVegetable/53": "verduras/castanas",
  "mainVegetable/54": "verduras/ciruela",
  "mainVegetable/55": "verduras/ensaladilla",
  "mainVegetable/56": "verduras/aceitunas-negras",
  "mainVegetable/57": "verduras/alcachofas",
  "mainVegetable/58": "verduras/pimientos-rojos",
  "mainVegetable/59": "verduras/judias-verdes-planas",
  "mainVegetable/60": "verduras/legumbres-de-primavera",
  "mainVegetable/61": "verduras/ratatouille",
  "mainVegetable/62": "verduras/cuscus",
  "mainVegetable/63": "verduras/tajine",
  "mainVegetable/64": "verduras/verduras-al-curry",
  "mainVegetable/65": "verduras/guisantes",
  "mainVegetable/66": "verduras/lentejas-de-coral",
  "mainVegetable/67": "verduras/quinoa",
  "mainVegetable/68": "verduras/espelta",
  "mainVegetable/69": "verduras/bulgur",
  "mainVegetable/70": "verduras/bulgur",
  "mainVegetable/71": "verduras/col-lombarda",
  "mainVegetable/72": "verduras/kale",
  "mainVegetable/73": "verduras/perifollo",
  "mainVegetable/74": "verduras/granos-y-semillas",
  "mainVegetable/75": "verduras/legumbres",
  "mainVegetable/76": "verduras/boniato",
  "mainVegetable/77": "verduras/calabaza",
  "mainVegetable/78": "verduras/acedera",
  "mainVegetable/79": "verduras/judias",
  "mainVegetable/80": "verduras/zanahorias-y-guisantes",
  "mainVegetable/81": "verduras/guisantes",
  "mainVegetable/82": "verduras/edamame",
  "mainVegetable/83": "verduras/cebada",
  "mainVegetable/84": "verduras/mezcla-ensalada",
  "mainVegetable/85": "verduras/endibia",
  "mainVegetable/86": "verduras/canonigos",
  "mainVegetable/87": "verduras/lechuga-batavia",
  "mainVegetable/88": "verduras/espinaca-baby",
  "mainVegetable/89": "verduras/acelga",
  "mainVegetable/90": "verduras",
  "mainVegetable/91": "verduras",
  "mainVegetable/92": "verduras",
  "mainVegetable/93": "verduras",
  "mainVegetable/94": "verduras",
  "mainVegetable/95": "verduras",
  "mainVegetable/96": "verduras",
  "mainVegetable/97": "verduras",
  "mainVegetable/98": "verduras",
  "productRange": "gamas",
  "productRange/4G_BIO": "gamas",
  "productRange/4G_SRP": "gamas",
  "productRange/CAN_A_POEL": "gamas",
  "productRange/CAN_SEC_BI": "gamas",
  "productRange/CAN_SEC_CO": "gamas",
  "productRange/CAN_SEC_CU": "gamas",
  "productRange/CAN_SEC_NA": "gamas",
  "productRange/CAN_VAPEUR": "gamas",
  "productRange/CAN_VEG_SA": "gamas",
  "productRange/CAN_VEG_SR": "gamas",
  "productRange/CLASSICVEG": "gamas",
  "productRange/COLDVEGE": "gamas",
  "productRange/COOKMUSH": "gamas",
  "productRange/CRUDITES": "gamas",
  "productRange/DE_NOS_PRO": "gamas",
  "productRange/DOYMUSHACC": "gamas",
  "productRange/DOYMUSHAPE": "gamas",
  "productRange/DRYVEGE": "gamas",
  "productRange/FROZENVEGE": "gamas",
  "productRange/FRZ_ASTUCE": "gamas",
  "productRange/FRZ_GRATIN": "gamas",
  "productRange/FRZ_KELLO": "gamas",
  "productRange/FRZ_LEG_CO": "gamas",
  "productRange/FRZ_PUREES": "gamas",
  "productRange/FRZ_VEG_BI": "gamas",
  "productRange/FRZ_VEG_SR": "gamas",
  "productRange/INDFROZVEG": "gamas",
  "productRange/JEUNES_POU": "gamas",
  "productRange/LAITUES": "gamas",
  "productRange/LOOP": "gamas",
  "productRange/LUNCH_BOWL": "gamas",
  "productRange/MACHE_BASE": "gamas",
  "productRange/MEL_LAITUE": "gamas",
  "productRange/MUSHNATEMI": "gamas",
  "productRange/MUSHNATENT": "gamas",
  "productRange/MUSHNATEPA": "gamas",
  "productRange/MUSHNATMIN": "gamas",
  "productRange/MUSHROOMS": "gamas",
  "productRange/SUNVEGE": "gamas",
  "productRange/TRAIT_CRUD": "gamas",
  "productRange/TRAIT_TABO": "gamas",
  "productRange/TUS_RECETA": "gamas",
  "productRange/WORLDVEGE": "gamas",
  "productRange/PREPARED_VEG": "gamas",
  "productRange/BEAN_SAUCE": "gamas",
  "productRange/BEANS": "gamas/judias",
  "productRange/BIO": "gamas/bio",
  "productRange/BOND_KIDS": "gamas",
  "productRange/CAN_BIO": "gamas",
  "productRange/CAN_SEC_PR": "gamas",
  "productRange/CARTA_DELL": "gamas",
  "productRange/CAN_PETITS": "gamas",
  "productRange/CAN_BOCAL": "gamas",
  "productRange/CEREAL_CAN": "gamas",
  "productRange/CEREAL_FRZ": "gamas",
  "productRange/CEREALI": "gamas",
  "productRange/CEREALLEGR": "gamas",
  "productRange/COCCOLE": "gamas",
  "productRange/CORN": "gamas/maiz",
  "productRange/CREATIF": "gamas",
  "productRange/FRANCAIS": "gamas",
  "productRange/FRZ_FRY_MI": "gamas",
  "productRange/FRZ_MELANG": "gamas",
  "productRange/FRZ_POELEE": "gamas",
  "productRange/INSALATE_D": "gamas",
  "productRange/INSALATONA": "gamas",
  "productRange/LE_REGIONA": "gamas",
  "productRange/LEGUMIO": "gamas",
  "productRange/MIXES_CORN": "gamas",
  "productRange/MONO_VEGE": "gamas",
  "productRange/MUSHROOMS  ": "gamas/champinones",
  "productRange/NATURA_IN": "gamas",
  "productRange/OTHER_VEG": "gamas/otros-vegetales",
  "productRange/PEAS": "gamas/guisantes",
  "productRange/READY_FROZ": "gamas/platos-cocinados-congelados",
  "productRange/SOUPS": "gamas",
  "productRange/SPINACH": "gamas/espinacas",
  "productRange/STEAM_CAN": "gamas",
  "productRange/STEAM_FRZ": "gamas",
  "productRange/STEAM_MIX": "gamas",
  "productRange/STUZZICHIA": "gamas",
  "productRange/TOUCHE": "gamas/un-toque-de",
  "productRange/TRAIT_SAL": "gamas",
  "productRange/TUS_RECETA ": "gamas/tus-recetas",
  "productRange/VEG_TO_FRY": "gamas",
  "productRange/VEGGIE": "gamas",
  "productRange/FRZ_JUSTEA": "gamas",
  "productRange/SALABIS": "gamas",
  "productRange/BON_SENGAG": "gamas",
  "productRange/CROUSTIS": "gamas",
  "season": "temporadas",
  "season/1": "temporadas/verano",
  "season/2": "temporadas/otono",
  "season/3": "temporadas/invierno",
  "season/4": "temporadas/primavera",
  "season/5": "temporadas",
  "technologie": "tecnologia",
  "technologie/AC01": "tecnologia/conserva",
  "technologie/AD01": "tecnologia/congelado",
  "technologie/AG01": "tecnologia/fresco",
  "technologie/AT01": "tecnologia/v-gama",
  "recipeDish": "tipo-de-plato",
  "recipeDish/ACC": "tipo-de-plato/acompanamiento",
  "recipeDish/APE": "tipo-de-plato/aperitivo",
  "recipeDish/DES": "tipo-de-plato/postre",
  "recipeDish/ENT": "tipo-de-plato/entrante",
  "recipeDish/PLAT": "tipo-de-plato/primer-plato",
  "recipeDish/SAL": "tipo-de-plato/ensalada",
  "recipeDish/SNA": "tipo-de-plato/snack",
  "recipeDish/PDE": "tipo-de-plato/desayuno",
  "recipeDish/DEJ": "tipo-de-plato/comida",
  "recipeDish/TRA": "tipo-de-plato/tradicional",
  "recipeDish/GOU": "tipo-de-plato/comida-gourmet",
  "recipeDish/ETH": "tipo-de-plato/etnica",
  "recipeDish/FCH": "tipo-de-plato/para-ninos",
  "recipeDish/SOU": "tipo-de-plato",
  "pred-recipeTimingCook-facet": "coccion",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "coccion/0-15-minutos",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "coccion/15-30-minutos",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "coccion/30-45-minutos",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "coccion/45-minutos",
  "pred-recipeTimingPreparation-facet": "preparacion",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "preparacion/0-15-minutos",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "preparacion/15-30-minutos",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "preparacion/30-45-minutos",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "preparacion/45-minutos",
  "pred-recipeCost-Facet": "presupuesto",
  "pred-recipeCost-Facet/petit": "presupuesto/barato",
  "pred-recipeCost-Facet/moyen": "presupuesto/medio",
  "pred-recipeCost-Facet/grand": "presupuesto/alto",
  "recipeDifficulty": "dificultad",
  "recipeDifficulty/1": "dificultad/facil",
  "recipeDifficulty/2": "dificultad/medio",
  "recipeDifficulty/3": "dificultad/dificil",
  "recipeDishNumber": "porciones",
  "recipeDishNumber/1": "porciones/1",
  "recipeDishNumber/2": "porciones/2",
  "recipeDishNumber/3": "porciones/3",
  "recipeDishNumber/4": "porciones/4",
  "recipeDishNumber/5": "porciones/5",
  "recipeDishNumber/6": "porciones/6",
  "recipeDishNumber/7": "porciones/7",
  "recipeDishNumber/8": "porciones/8",
  "productTheme": "productos-por-tema",
  "productTheme/ACC": "productos-por-tema/acompanamiento",
  "productTheme/BEA": "productos-por-tema/judias",
  "productTheme/BIS": "productos-por-tema/judias-en-salsa",
  "productTheme/BIO": "productos-por-tema/bio",
  "productTheme/CAN": "productos-por-tema/conserva",
  "productTheme/CER": "productos-por-tema",
  "productTheme/CLS": "productos-por-tema/clasicos",
  "productTheme/DLE": "productos-por-tema/vegetales",
  "productTheme/EDR": "productos-por-tema/enriquecedores",
  "productTheme/ENT": "productos-por-tema/entrantes",
  "productTheme/FRZ": "productos-por-tema/congelados",
  "productTheme/FSD": "productos-por-tema/para-ensaladas",
  "productTheme/FSH": "productos-por-tema/frescos",
  "productTheme/ING": "productos-por-tema/ingredientes-para-mis-recetas",
  "productTheme/JAR": "productos-por-tema/verduras-en-frasco",
  "productTheme/LBW": "productos-por-tema/listo-para-comer",
  "productTheme/LDF": "productos-por-tema/verduras-al-horno",
  "productTheme/LEG": "productos-por-tema/las-legumbres",
  "productTheme/LGO": "productos-por-tema/legumio",
  "productTheme/LGR": "productos-por-tema/verduras-al-grill",
  "productTheme/LGS": "productos-por-tema",
  "productTheme/MAI": "productos-por-tema/el-maiz",
  "productTheme/MUS": "productos-por-tema/champinones",
  "productTheme/NEW": "productos-por-tema/nuevos-productos",
  "productTheme/PDH": "productos-por-tema/platos-de-cocina-de-legumbres",
  "productTheme/PDL": "productos-por-tema/cesta-de-verduras",
  "productTheme/PHR": "productos-por-tema/para-tus-recetas",
  "productTheme/PLP": "productos-por-tema/plato-principal",
  "productTheme/RAL": "productos-por-tema/arroz-vegetal",
  "productTheme/RDM": "productos-por-tema/platos-de-cocina",
  "productTheme/SAL": "productos-por-tema/todo-para-mis-ensaladas",
  "productTheme/SDB": "productos-por-tema/bowls-de-ensalada",
  "productTheme/SNK": "productos-por-tema/snacking",
  "productTheme/SUP": "productos-por-tema/sopa",
  "productTheme/TEX": "productos-por-tema/tex-mex",
  "productTheme/VGP": "productos-por-tema/proteinas-vegetales",
  "recipeTheme": "recetas-por-tema",
  "recipeTheme/01": "recetas-por-tema/recetas-festivas",
  "recipeTheme/02": "recetas-por-tema/aperitivos",
  "recipeTheme/03": "recetas-por-tema/ensaladas-y-snacks",
  "recipeTheme/04": "recetas-por-tema/sopas-y-gazpachos",
  "recipeTheme/05": "recetas-por-tema/quiches-tartas-y-gratinados",
  "recipeTheme/06": "recetas-por-tema/especial-para-ninos",
  "recipeTheme/07": "recetas-por-tema/postres",
  "recipeTheme/08": "recetas-por-tema/vegetarianos",
  "recipeTheme/09": "recetas-por-tema/acompanamiento",
  "recipeTheme/10": "recetas-por-tema/come-from-away",
  "recipeTheme/11": "recetas-por-tema/guisos",
  "recipeTheme/12": "recetas-por-tema/ensaladas-y-barbacoas",
  "recipeTheme/13": "recetas-por-tema/snacks-y-fingerfood",
  "recipeTheme/14": "recetas-por-tema/plato-principal",
  "recipeTheme/15": "recetas-por-tema/postres-y-pasteles",
  "recipeTheme/16": "recetas-por-tema/entrantes-y-sopas",
  "recipeTheme/17": "recetas-por-tema/ensaladas",
  "recipeTheme/18": "recetas-por-tema/bowls",
  "recipeTheme/19": "recetas-por-tema/sopas",
  "recipeTheme/20": "recetas-por-tema/snacks",
  "recipeTheme/21": "recetas-por-tema/salsa",
  "recipeTheme/22": "recetas-por-tema/platos-unicos",
  "recipeTheme/23": "recetas-por-tema/otros-platos",
  "recipeTheme/24": "recetas-por-tema/platos-al-horno",
  "recipeTheme/25": "recetas-por-tema",
  "recipeTheme/26": "recetas-por-tema",
  "recipeTheme/27": "recetas-por-tema",
  "recipeTheme/28": "recetas-por-tema",
  "recipeTheme/33": "recetas-por-tema",
  "recipeTheme/34": "recetas-por-tema",
  "recipeTheme/35": "recetas-por-tema",
  "recipeTheme/36": "recetas-por-tema",
  "recipeTheme/37": "recetas-por-tema",
  "recipeTheme/38": "recetas-por-tema",
  "recipeTheme/39": "recetas-por-tema",
  "recipeTheme/40": "recetas-por-tema",
  "recipeTheme/41": "recetas-por-tema",
  "recipeTheme/42": "recetas-por-tema",
  "recipeTheme/43": "recetas-por-tema",
  "recipeTheme/44": "recetas-por-tema",
  "recipeTheme/45": "recetas-por-tema",
  "recipeTheme/46": "recetas-por-tema",
  "pred-particularite": "habitos-alimenticios",
  "pred-particularite/Sans%20conservateur": "habitos-culinarios/sin-conservantes",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "habitos-culinarios",
  "pred-particularite/Sans%20colorant": "habitos-culinarios/sin-colorantes",
  "pred-particularite/Sans%20sucre%20ajout%E9": "habitos-culinarios/sin-azucares-anadidos",
  "pred-particularite/Sans%20sel%20ajout%E9": "habitos-culinarios/sin-sal-anadida",
  "pred-particularite/Sans%20additif": "habitos-culinarios/sin-aditivos",
  "pred-particularite/": "habitos-culinarios/sal-naturalmente-presente",
  "pred-particularite/Sans%20lactose": "habitos-culinarios/sin-lactosa",
  "pred-particularite/Sans%20gluten": "habitos-culinarios/sin-gluten",
  "pred-particularite/V%E9g%E9tarien": "habitos-culinarios/vegetariano",
  "pred-particularite/V%E9g%E9talien": "habitos-culinarios/vegano",
  "pred-particularite/Sans%20sulfite": "habitos-culinarios/sin-sulfitos",
  "pred-particularite/A%20la%20vapeur": "habitos-culinarios",
  "pred-particularite/Sans%20condiment": "habitos-culinarios",
  "cultureType": "tipo-de-cultivo",
  "cultureType/Bio": "tipo-de-cultivo/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "tipo-de-cultivo/sin-residuos-de-pesticidas",
  "cultureType/Sans%20OGM": "tipo-de-cultivo/sin-ogm",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "habitos-alimenticios/vegano",
  "pred-particularite/recipeVeggie": "habitos-alimenticios/vegetariano",
  "pred-particularite/recipeGlutenfree": "habitos-alimenticios/sin-gluten",
  "pred-particularite/recipeLactosefree": "habitos-alimenticios/sin-lactosa"
};
